import React from 'react';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import EditCompany from './EditCompany';
import { Paper, Typography } from '@mui/material';
import { StandardPageHeader } from 'app/shared/ui';
import { canEditShifts } from 'app/shared/downloads/permissions';
import WorkShiftsEditor from 'app/shared/reports/WorkShiftsEditor';


const CompanySettings = () => {
    const {authUser} = useJumboAuth();

    return (
        <div>
            <StandardPageHeader title="Configuraciones" />
            { authUser && <EditCompany company_id={authUser?.current_company?.id} /> }
            { canEditShifts(authUser) && (
                <Paper variant="outlined" sx={{ mt: 2, p: 2.25 }}>
                    <Typography variant="h4" sx={{ mb: 0.5 }}>Turnos para reportes</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Los reportes por turno agrupan las lecturas con estos turnos. Un local puede tener los suyos desde su menú en Locales.
                    </Typography>
                    <WorkShiftsEditor />
                </Paper>
            )}
        </div>
    );
};

export default CompanySettings;
